import { render, staticRenderFns } from "./SubpaymentItemDisplay.vue?vue&type=template&id=054e6be5&scoped=true&"
import script from "./SubpaymentItemDisplay.vue?vue&type=script&lang=js&"
export * from "./SubpaymentItemDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SubpaymentItemDisplay.vue?vue&type=style&index=0&id=054e6be5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054e6be5",
  null
  
)

export default component.exports